module.exports = __webpack_public_path__ + "img/move-expense.601e9fc7.svg";